import { GBannerAppDownload } from '@gazin/ecommerce-ui'
import { useEffect, useState } from 'react'
import { DeviceType, getDeviceType } from 'src/util/getDeviceType'

type BannerAppDownloadOrAccessProps = {
  productSlug: string
  productId: string | number
  colorSlug: string
  voltageSlug: string
}

export const BannerAppDownloadOrAccess = ({
  productSlug,
  productId,
  colorSlug,
  voltageSlug,
}: BannerAppDownloadOrAccessProps) => {
  const [deviceType, setDeviceType] = useState<DeviceType | ''>('')

  useEffect(() => {
    const userAgent = navigator.userAgent

    const typeOfDevice = getDeviceType(userAgent)

    setDeviceType(typeOfDevice)
  }, [])

  const openAppWithDeepLink = async (deepLink: string) => {
    return new Promise<boolean>((resolve, reject) => {
      const timeout = setTimeout(() => {
        reject(new Error('Tempo limite para abrir o aplicativo excedido.'))
      }, 2500)

      const successCallback = () => {
        clearTimeout(timeout)
        resolve(true)
      }

      const errorCallback = (error: any) => {
        clearTimeout(timeout)
        reject(error)
      }

      window.addEventListener('pagehide', errorCallback, { once: true })
      window.addEventListener('pageshow', successCallback, { once: true })

      window.location.href = deepLink
    })
  }

  const redirectToAppStore = (appStoreURL: string) => {
    window.location.href = appStoreURL
  }

  const handleAppOpen = async () => {
    const iosDeepLinkGazin = `gazin://produto/${productSlug}/${productId}/${colorSlug}/${voltageSlug}`
    const androidDeepLinkGazin = `gazin://gazin/produto/${productSlug}/${productId}/${colorSlug}/${voltageSlug}`
    const appleStoreAppURL =
      'itms-apps://itunes.apple.com/br/app/gazin-compras-online/id1541397077'
    const playStoreAppURL = 'market://details?id=com.b2capp'

    try {
      if (deviceType.includes('ios')) {
        await openAppWithDeepLink(iosDeepLinkGazin)
      } else if (deviceType.includes('android')) {
        await openAppWithDeepLink(androidDeepLinkGazin)
      }
    } catch {
      if (deviceType.includes('ios')) {
        redirectToAppStore(appleStoreAppURL)
      } else if (deviceType.includes('android')) {
        redirectToAppStore(playStoreAppURL)
      }
    }
  }

  return (
    <GBannerAppDownload
      buttonLabel="Baixar"
      message="Baixe o aplicativo e compre com mais facilidade."
      buttonVariant="secondary"
      width="100%"
      handleDownloadOrAccessApplication={handleAppOpen}
      css={{
        p: {
          marginBottom: 0,
        },
      }}
    />
  )
}
